import type { ReferralStatus } from '@cortex/domain';
import type { StatusBadgeTone } from './StatusBadge';

/**
 * The referral review lifecycle — single source of truth for the UI.
 *
 * Mirrors `ReferralStatusSchema` in `@cortex/domain` (`open → approved /
 * declined`, with `expired` as the time-out terminal state). Anything that
 * renders a referral status reads its tone and label from here so the
 * vocabulary stays identical wherever referrals surface.
 */
export const toneForReferralStatus = (status: ReferralStatus): StatusBadgeTone => {
  switch (status) {
    case 'open':
      return 'pending';
    case 'approved':
      return 'active';
    case 'declined':
      return 'danger';
    case 'expired':
      return 'neutral';
  }
};

export const REFERRAL_STATUS_LABELS: Readonly<Record<ReferralStatus, string>> = {
  open: 'Open',
  approved: 'Approved',
  declined: 'Declined',
  expired: 'Expired',
};
